import React, { Component } from 'react'
import styled from 'styled-components'

const _NavArrow = ({ className, width, height, ...rest }) => {
  return (
    <svg className={className} width={width} height={height} {...rest} viewBox="0 0 13 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path fill="#f1f1f1" d="M12.7.29a1,1,0,0,0-1.37,0L.27,11.32a1,1,0,0,0,0,1.4l11,11a1,1,0,0,0,1.42-1.41L2.39,12,12.74,1.67A1,1,0,0,0,12.7.29Z"/>
    </svg>
  )
}

const NavArrow = styled(_NavArrow)`
  ${props => props.direction == 'next' && `
    transform: rotateZ(180deg);
  `}
`

export default NavArrow



// WEBPACK FOOTER //
// ./src/components/visuals/NavArrow.js